export class QuotaRoutes
{
    static Home: string = "/";

    // Request
    static RequestList: string = "/request/list";
    static RequestNew: string = "/request/new";
    static RequestCopy(id: string)
    {
        return `/request/${id}/new`;
    }
    static RequestEdit(id: string)
    {
        return `/request/${id}/edit`;
    }
    static RequestView(id: string)
    {
        return `/request/${id}/view`;
    }

    // Usage
    static Usage: string = "/usage";
}